<template>
    <div class="contact-us py-16">
      <v-container>
        <v-card class="pa-5">
          <h1>Contact Us</h1>
          
          <v-row>
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">
              <v-form v-model="valid" ref="form">
                <v-text-field
                  v-model="name"
                  label="Name"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
  
                <v-text-field
                  v-model="email"
                  label="Email"
                  :rules="[rules.email, rules.required]"
                  required
                ></v-text-field>
  
                <v-textarea
                  v-model="message"
                  label="Message"
                  :rules="[rules.required]"
                  required
                ></v-textarea>
  
                <v-btn
                  large
                  class="primary text-capitalize"
                  @click="submitForm"
                  :disabled="!valid"
                >
                  Send Message
                </v-btn>
              </v-form>
            </v-col>
  
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 6">
              <v-card>
                <v-card-title>Contact Information</v-card-title>
                <v-card-text>
                  <p>
  <v-icon @click="openLink('tell')" class="mr-2">mdi-phone</v-icon>
  <strong>Phone:</strong> 0689118095 | 0749391961 | 0766789867
</p>
<p>
  <v-icon @click="openLink('mailto:kasanaautogarage@gmail.com')" class="mr-2">mdi-email</v-icon>
  <strong>Email:</strong> kasanaautogarage@gmail.com
</p>
<p>
  <v-icon @click="openLink('https://maps.app.goo.gl/Li921T6MYBxjADGj8')" class="mr-2">mdi-domain</v-icon>
  <strong>Address:</strong> Kasana Street, Kinondoni, Dar es Salaam
</p>

                  <v-divider></v-divider>
                  <v-card-title>Follow Us</v-card-title>
                  <v-btn icon :href="'tel: ' + phone">
            <v-icon>mdi-phone</v-icon>
          </v-btn>
                  <v-icon @click="openLink(' https://wa.me/255749391961')" class="mr-2">mdi-whatsapp</v-icon>
                  <v-icon @click="openLink('https://www.facebook.com/share/YiW1mhjWb84LWc1d/?mibextid=qi2Omg')" class="mr-2">mdi-facebook</v-icon>
                  <v-icon @click="openLink('https://x.com/hassankashmal?t=QzDECh-Hv1emIwT8iEyvBQ&s=01')" class="mr-2">mdi-twitter</v-icon>
                  <v-icon @click="openLink('https://www.instagram.com/hassanayn_kashmal?igsh=bDJ0emc1bXB2MmU0')">mdi-instagram</v-icon>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-container>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ContactUs',
    data() {
      return {
        phone: '0689118095',
        name: '',
        email: '',
        message: '',
        valid: false,
        rules: {
          required: (value) => !!value || 'Required.',
          email: (value) => {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailPattern.test(value) || 'Invalid email.';
          },
        },
      };
    },
    methods: {
      submitForm() {
       
        if (this.$refs.form.validate()) {
         
          alert('Message sent! Thank you for contacting us.');
          this.resetForm();
        }
      },
      resetForm() {
        this.name = '';
        this.email = '';
        this.message = '';
        this.valid = false;
      },
      openLink(url) {
        window.open(url, '_blank');
      },
    },
  };
  </script>
  
  <style scoped>
  .contact-us {
    background-color: #f9f9f9;
  }
  </style>
  